import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { TooltipOnHover } from './TooltipOnHover';
var COLOR_SCHEMES = {
  // default, metabar, navigation
  grayOnWhite: 'shade-20 shade-10-on-hover background-shade-50-on-hover background-shade-45-on-active',
  grayOnWhiteDisabled: 'shade-40',
  // default, metabar, navigation
  grayOnGray: 'shade-20 shade-10-on-hover background-shade-40-on-hover background-shade-30-on-active',
  grayOnGrayDisabled: 'shade-40',
  // order by recent in note list
  primaryOnWhite: 'background-primary-shade-light background-primary-shade-light-on-active background-primary-shade-dark-on-hover primary',
  primaryOnWhiteDisabled: 'primary',
  // quick switch
  whiteOnDark: 'shade-10 shade-05-on-hover background-shade-50-on-hover',
  whiteOnDarkDisabled: 'opacity-large'
};
var BOX_SIZES = {
  smaller: 20,
  small: 24,
  "default": 32
};
var IconButton = React.forwardRef(function (_ref, ref) {
  var _ref$boxSize = _ref.boxSize,
      boxSize = _ref$boxSize === void 0 ? 'default' : _ref$boxSize,
      className = _ref.className,
      tooltip = _ref.tooltip,
      tooltipPosition = _ref.tooltipPosition,
      children = _ref.children,
      style = _ref.style,
      _ref$colorScheme = _ref.colorScheme,
      colorScheme = _ref$colorScheme === void 0 ? 'grayOnWhite' : _ref$colorScheme,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      otherProps = _objectWithoutProperties(_ref, ["boxSize", "className", "tooltip", "tooltipPosition", "children", "style", "colorScheme", "disabled"]);

  var _style = _objectSpread({
    width: BOX_SIZES[boxSize],
    height: BOX_SIZES[boxSize]
  }, style);

  var enhancedClassName = classNames('flexbox', {
    pointer: !disabled
  }, 'transition', 'flexbox-centered', 'radius-normal', disabled ? COLOR_SCHEMES["".concat(colorScheme, "Disabled")] : COLOR_SCHEMES[colorScheme], className);
  var content = React.createElement("div", {
    className: "inline-block",
    ref: ref
  }, React.createElement("span", Object.assign({
    className: enhancedClassName,
    style: _style
  }, otherProps), children));
  return !tooltip ? content : React.createElement(TooltipOnHover, {
    id: "tooltip",
    tooltipContent: tooltip,
    placement: tooltipPosition
  }, content);
});
IconButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  colorScheme: PropTypes.oneOf(Object.keys(COLOR_SCHEMES)),
  boxSize: PropTypes.oneOf(Object.keys(BOX_SIZES)),
  tooltip: PropTypes.node,
  tooltipPosition: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool
};
export default IconButton;